import { render, staticRenderFns } from "./printer.vue?vue&type=template&id=df2fa926&scoped=true"
import script from "./printer.ts?vue&type=script&lang=ts&external"
export * from "./printer.ts?vue&type=script&lang=ts&external"
import style0 from "./printer.scoped.scss?vue&type=style&index=0&id=df2fa926&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2fa926",
  null
  
)

export default component.exports